export { BdcAuthor } from "./pages/bdcAuthorManagement";
